import {default as Component} from './UserLoginForm'
import {changeUsername, changePassword} from '../../redux/actions'
import {login, getResources} from '../../redux/endpointActions'
import {connect} from 'react-redux'
import {ACTION_TYPE} from "../../redux/types";

const servicePath = process.env.REACT_APP_SERVICE_ENDPOINT + 'user/token'
const resourcePath = process.env.REACT_APP_SERVICE_ENDPOINT + 'user/domain/resource'

const UserLoginForm = connect(
	(state) => ({
		username: state.userInfo.username,
		password: state.userInfo.password,
		disabled: state.loginForm.disabled,
		err: state.loginForm.err
	}),
	(dispatch) => ({
		submit: (username, password) => {
			login(servicePath)(username, password)(dispatch)
                .then((data) => {
                    if (data.type === ACTION_TYPE.LOGIN_RESPONSE) {
                        return getResources(resourcePath, JSON.parse(data.body.body).AuthenticationResult.IdToken)()(dispatch)
                    } else {
                        return {}
                    }
                })
		},
		usernameChanged: (username) => {
            dispatch(changeUsername(username))  
		},
		passwordChanged: (password) => {
			dispatch(changePassword(password))
		}
	})
)(Component)

UserLoginForm.defaultProps = {
	username: null,
	password: null,
	submit: null,
	usernameChanged: null,
	passwordChanged: null,
	disabled: null
}

export default UserLoginForm


// WEBPACK FOOTER //
// ./src/components/UserLoginForm/index.js